import React from 'react';
import style from './SellModal.module.css';
import PrimaryCTA from '../../components/PrimaryCTA/PrimaryCTA';
import FormInput from '../../components/FormInput/FormInput';


const SellModal = props => {
	return (
		<div className={style.SellModal}>
			<span>
				Sell {props.ad.sellToken} to {props.ad.username} for {props.ad.fiatCurrency}</span>

			<FormInput
				title={props.ad.sellToken + ' Amount'}
			/>

			{/* <div>
				<span>ngn amt</span>
				<input type="text" />
			</div> */}

			<FormInput
				title={props.ad.fiatCurrency + ' Amount'}
			/>

			{/* Buyers wallet Address, add to DB */}
			{/* <div>
				<span>Buyer's Wallet Address</span>
				<input type="text" />
			</div> */}

			{/* Sellers sending address somewhere */}
			{/* Add a dropdown to choose from */}

			<FormInput
				title={'Address to send from'}
			/>

			{/* Add a dropdown to choose from */}
			<FormInput
				title={'Bank account to RECIEVE payment'}
			/>
			
			<FormInput
				title={'PIN'}
			/>



			<div className={style.DialogueBoxButtons}>
				<PrimaryCTA
					ButtonText='Accept'
					click={() => props.AcceptAction()}
				/>

				<PrimaryCTA
					ButtonText='Cancel'
					click={() => props.CancelAction()}
				/>
			</div>
		</div>
	)
}

export default SellModal;